<template>
    <img
      alt="AMSN"
      class=""
      src="/assets/AMSN.webp"
      width=""
      height=""
    >
</template>
